const utils = (storeUtils = window.flex) => {

    const { getStore } = storeUtils;

    function isFeatureToggleEnabled(featureName) {
        const store = getStore().toJS();
        const features = store.appContext.features || [];
        const currentFeature = features.find(feature => feature.name === featureName);
        return !!currentFeature && currentFeature.enabled;
    }

    return {
        isFeatureToggleEnabled
    };
}

module.exports = utils;